@if (remainingTime > 0) {
  <div class="countdown-container">Session expires in: {{ remainingTimeFormatted }}</div>
}
